import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import {
  UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import _ from 'lodash';

import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';

import ROUTES from '../../../../config/routes';

import { getDailyLoadsList, deleteDailyLoad } from '../../../../app/store/actions/dailyLoads';

class DailyLoadList extends React.Component {
  constructor(props) {
    super(props);

    this.page = 0;
    this.pageSize = 10;
    this.sorted = [];
    this.filtered = [];

    this.state = {
      showModalDelete: false,
      dailyLoadUpdate: null,
      pages: 0,
      totalDataLength: 0,
    };

    this.defaultSorted = [
      {
        id: 'position',
        desc: false,
      },
    ];
    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                <DropdownItem onClick={() => this.showDailyLoadDetail(rows.row)}>{I18n.t('BEE56' /* Detalhes */)}</DropdownItem>
                <DropdownItem onClick={() => this.showEditDailyLoad(rows.row)}>{I18n.t('BEE57' /* Editar */)}</DropdownItem>
                <DropdownItem onClick={() => this.showCopyDailyLoad(rows.row)}>{I18n.t('BEE80' /* Copiar */)}</DropdownItem>
                <DropdownItem onClick={() => this.showDeleteDailyLoad(rows.row)}>{I18n.t('BEE81' /* Eliminar */)}</DropdownItem>
                <DropdownItem onClick={() => this.showLinkCarriers(rows.row)}>{I18n.t('BEE2377' /* Vincular Transportadoras */)}</DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE3937' /* Posição */),
        accessor: 'position',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3938' /* Descrição no Dashboard */),
        accessor: 'description',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 300,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branch.name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'active',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
        Cell: ({ value }) => (
          <span
            className={`badge ${value ? 'badge-success' : 'badge-danger'}`}
            style={{ padding: '5px 10px', borderRadius: '5px' }}
          >
            {value ? I18n.t('BEE499' /* Ativo */) : I18n.t('BEE1137' /* Inativo */)}
          </span>
        ),
      }, {
        Header: I18n.t('BEE135' /* Observação */),
        accessor: 'note',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: this.filterColumn,
      },
    ];
  }

  componentDidMount() {
    this.maintainsState();
  }

  maintainsState = async () => {
    if (this.props.location.state && this.props.location.state.dice) {
      this.setState({
        page: this.props.location.state.dice.page,
        firstRun: true,
      });
    }
  };

  setInitState = () => {
    this.setState({
      showModalDelete: false,
      dailyLoadUpdate: null,
    });
  };

  filterColumn = ({ filter, onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  filterColumnSelect = ({ filter, onChange }) => (
    <select
      type="text"
      style={{ width: '100%' }}
      onChange={(event) => {
        onChange(event.target.value);
      }}
    >
      <option value={0}>{I18n.t('BEE793' /* Todos */)}</option>
      <option value={1}>{I18n.t('BEE292' /* Rodoviário */)}</option>
      <option value={2}>{I18n.t('BEE293' /* Aeroviário */)}</option>
      <option value={3}>{I18n.t('BEE295' /* Ferroviário */)}</option>
      <option value={4}>{I18n.t('BEE294' /* Marítimo */)}</option>
      <option value={5}>{I18n.t('BEE296' /* Outros */)}</option>
    </select>
  );

  getDailyLoads = async () => {
    const data = await this.props.getDailyLoadsList({
      page: this.page,
      pageSize: this.pageSize,
      sorted: this.sorted,
      filtered: this.filtered,
    });
    this.setState({ pages: data.pages, totalDataLength: data.totalDataLength });
  };

  deleteDailyLoad = async (dailyLoad) => {
    const result = await this.props.deleteDailyLoad(dailyLoad._original.id);

    this.setInitState();
    if (result) {
      addNotification(
        'success',
        I18n.t('BEE3939' /* Eliminar Carregamento Diário */),
        I18n.t('BEE3940', { 0: dailyLoad.code } /* Carregamento diário %{0} eliminado com sucesso. */),
        'top-right',
      );
    }
    await this.getDailyLoads();
  };

  showDailyLoadDetail = (dailyLoad) => {
    this.props.history.push({
      pathname: ROUTES.DAILY_SHIPMENT_DETAIL,
      state: {
        dailyLoad: dailyLoad._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  showEditDailyLoad = (dailyLoad) => {
    this.props.history.push({
      pathname: ROUTES.DAILY_SHIPMENT_EDIT,
      state: {
        dailyLoad: dailyLoad._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  showCopyDailyLoad = (dailyLoad) => {
    this.props.history.push({
      pathname: ROUTES.DAILY_SHIPMENT_COPY,
      state: {
        dailyLoad: dailyLoad._original,
      },
    });
  };

  showDeleteDailyLoad = (dailyLoad) => {
    this.setState({ showModalDelete: true, dailyLoadUpdate: dailyLoad });
  };

  showLinkCarriers = (dailyLoad) => {
    this.props.history.push({
      pathname: ROUTES.DAILY_SHIPMENT_LINK_CARRIER,
      state: {
        dailyLoad: dailyLoad._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  render() {
    const {
      dailyLoadUpdate, showModalDelete, pages, page, totalDataLength,
    } = this.state;
    const { dailyLoadsList = [] } = this.props;

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE3933' /* Carregamentos Diários */)}</li>
          </ol>
        </div>
        <Table
          downloadCSV
          wikiHelp={ROUTES.DAILY_SHIPMENT_HELP}
          headerTitle={I18n.t('BEE3933' /* Carregamentos Diários */)}
          actionButtons={(
            <div className="ml-auto">
              <Link to={ROUTES.DAILY_SHIPMENT_CREATE} className="btn btn-success btn-sm btn-rounded pl-2 pr-3">
                <i className="fa fa-plus mr-1" />
                {' '}
                {I18n.t('BEE3936' /* Incluir Carregamento */)}
              </Link>
            </div>
          )}
          panelHeaderProps={{
            onClickReload: this.getDailyLoad,
          }}
          filterable
          data={dailyLoadsList}
          totalDataLength={totalDataLength}
          columns={this.tableColumns}
          expander
          defaultPageSize={10}
          defaultSorted={this.defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          manual
          pages={pages}
          page={(page) || ((!this.state.firstRun && this.props.location.state && this.props.location.state.dice && this.props.location.state.dice.page) ? this.props.location.state.dice.page : page)}
          onPageChange={(page) => ((page >= 0) ? this.setState({ page }) : this.setState({ page: 0 }))}
          onFetchData={(state, instance) => {
            this.page = (state.page) ? state.page : (!this.state.firstRun && this.props.location.state && this.props.location.state.dice && this.props.location.state.dice.page) ? this.props.location.state.dice.page : state.page;
            this.pageSize = state.pageSize;
            this.sorted = state.sorted;
            this.filtered = state.filtered;
            this.getDailyLoads();
          }}
        />
        {(showModalDelete
          && (
            <SweetAlert
              danger
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.deleteDailyLoad(dailyLoadUpdate)}
              onCancel={() => this.setInitState()}
            >
              {I18n.t('BEE300', { 0: dailyLoadUpdate.code } /* A transportadora %{0} será eliminada! */)}
            </SweetAlert>
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dailyLoadsList: state.dailyLoads && state.dailyLoads.dailyLoadsList,
});

const mapDispatchToProps = (dispatch) => ({
  getDailyLoadsList: (tableParams) => dispatch(getDailyLoadsList(tableParams)),
  deleteDailyLoad: (dailyLoadId) => dispatch(deleteDailyLoad(dailyLoadId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DailyLoadList));
